const MAX_ELEMENTS_IN_VIEW = 5;

type Page = {
  page: number;
  isHiddenInMobile?: boolean;
  needsEllipsisInMobile?: boolean;
};

function createArray(length: number, initialValue: number): number[] {
  if (length <= 0) return [];
  return Array(length)
    .fill(initialValue)
    .map((value, index) => index + value);
}

export function calculatePaginationPages(
  currentPage: number,
  pagesCount: number,
): Page[] {
  let pages: Page[];
  const halfPagesCount = pagesCount / 2;

  if (pagesCount <= 2) {
    pages = [];
  } else if (pagesCount - 2 <= MAX_ELEMENTS_IN_VIEW) {
    const [lowerBound, upperBound] =
      pagesCount % 2 === 0
        ? [halfPagesCount, halfPagesCount + 1]
        : [Math.floor(halfPagesCount), Math.ceil(halfPagesCount)];
    pages = createArray(pagesCount - 2, 2).map((page) => ({
      page,
      isHiddenInMobile:
        pagesCount - 2 === MAX_ELEMENTS_IN_VIEW &&
        ((currentPage <= lowerBound &&
          page > upperBound &&
          page < pagesCount) ||
          (currentPage > lowerBound && page < upperBound)),
      needsEllipsisInMobile:
        pagesCount - 2 === MAX_ELEMENTS_IN_VIEW &&
        ((currentPage <= lowerBound && page === upperBound + 1) ||
          (currentPage > lowerBound && page === upperBound - 1)),
    }));
  } else if (currentPage < MAX_ELEMENTS_IN_VIEW) {
    pages = createArray(MAX_ELEMENTS_IN_VIEW - 1, 2).map((page) => ({
      page,
      isHiddenInMobile:
        (currentPage < MAX_ELEMENTS_IN_VIEW - 1 &&
          page === MAX_ELEMENTS_IN_VIEW) ||
        (currentPage >= MAX_ELEMENTS_IN_VIEW - 1 &&
          page < MAX_ELEMENTS_IN_VIEW - 1),
      needsEllipsisInMobile:
        currentPage >= MAX_ELEMENTS_IN_VIEW - 1 && page === 2,
    }));
  } else if (currentPage > pagesCount - MAX_ELEMENTS_IN_VIEW + 1) {
    const limit = pagesCount - MAX_ELEMENTS_IN_VIEW + 1;
    pages = createArray(
      MAX_ELEMENTS_IN_VIEW - 1,
      pagesCount - MAX_ELEMENTS_IN_VIEW + 1,
    ).map((page) => ({
      page,
      isHiddenInMobile:
        (currentPage === limit && page < limit) ||
        (currentPage > limit && page <= limit),
    }));
  } else {
    pages = createArray(MAX_ELEMENTS_IN_VIEW - 2, currentPage - 1).map(
      (page) => ({
        page,
        isHiddenInMobile: page === currentPage - 1,
      }),
    );
  }

  pages.unshift({ page: 1 });

  if (pages.at(0)?.page !== pagesCount) {
    pages.push({ page: pagesCount });
  }

  return pages;
}
